module.exports = __webpack_public_path__ + "img/categoryDemo.d4620e9c.jpg";